import setImmediate from "setimmediate";
import Provider from "components/Provider";
import App from "components/App";
import React from "react";
import ReactDOM from "react-dom";

import Dispatcher from "flux/Dispatcher";
import SongStore from "stores/SongStore";
import NavigationStore from "stores/NavigationStore";
import ErrorStore from "stores/ErrorStore";
import UserStore from "stores/UserStore";


import AudioLayer from "../audio/AudioLayer";
import MidiLayer from "../midi/MidiLayer";

import "scss/app.scss";


var dispatcher = new Dispatcher();

var audioLayer = new AudioLayer(dispatcher);
var midiLayer = new MidiLayer(dispatcher);


dispatcher.registerStore(SongStore);
dispatcher.registerStore(NavigationStore);
dispatcher.registerStore(ErrorStore);
dispatcher.registerStore(UserStore);

const state = window.currentState || {};

dispatcher.rehydrate(state);

audioLayer.start();
midiLayer.start();

render();
function render() {

    const rootEl = document.createElement('div');
    document.body.appendChild(rootEl);

    ReactDOM.render(
        <Provider dispatcher={dispatcher}>
            <App/>
        </Provider>,
        rootEl
    );
}







